import { createUseStyles } from 'react-jss'
import { darkGrey, lightGrey, trafficRedDark } from '../../styles/const/colors'

const useStyles = createUseStyles({
  tableWrapper: {
    maxHeight: 309,
    overflow: 'auto',
    lineHeight: 0
  },
  table: {
    width: '100%',
    fontSize: 12,
    '& .Spreadsheet__cell, & .Spreadsheet__header': {
      height: 28,
      borderColor: lightGrey,
      color: darkGrey,
      verticalAlign: 'middle'
    },
    '& .Spreadsheet__cell': {
      background: 'white'
    },
    '& .Spreadsheet__header': {
      background: lightGrey,
      minWidth: 0,
      padding: '0 12px',
      position: 'relative',
      overflow: 'visible',
      '&.error': {
        color: trafficRedDark
      }
    }
  },
  errorHighlighter: {
    height: 'calc(100% + 2px)',
    width: 'calc(100% + 2px)',
    position: 'absolute',
    top: -1,
    border: `1px solid ${trafficRedDark}`,
    left: -1
  },
  addNewRowButton: {
    display: 'block',
    margin: '16px auto 0'
  }
})

export default useStyles
